module.exports = __webpack_public_path__ + "static/media/Charing cross Pavillion c. 1960s no Statue.c5b63cd5.jpg";